<template>
  <ValidationObserver
    v-bind="$attrs"
    v-on="$listeners"
    v-slot="v"
    ref="observer"
  >
    <slot v-bind="v"></slot>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
  components: { ValidationObserver },

  mounted() {
    // $refs are not reactive, so a watch has to be applied manually.
    const unwatch = this.$watch(
      () => this.$refs.observer.flags.valid,
      (val) => {
        this.$emit(`validation-${val ? 'passed' : 'failed'}`);
      },
      { immediate: true }
    );

    this.$once('hook:beforeDestroy', unwatch);
  }
};
</script>
